import { render, staticRenderFns } from "./ReturnDialog.vue?vue&type=template&id=c8f93c44&"
import script from "./ReturnDialog.vue?vue&type=script&lang=js&"
export * from "./ReturnDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports